/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserRole } from './userRole';
import type { UserLifecycleState } from './userLifecycleState';
import type { UserTitle } from './userTitle';
import type { UserTrialProperty } from './userTrialProperty';
import type { UserCohort } from './userCohort';
import type { UserContext } from './userContext';
import type { UserAvatar } from './userAvatar';
import type { UserProfilePhotoBlobPath } from './userProfilePhotoBlobPath';
import type { UserFeatures } from './userFeatures';
import type { UserExternalStudentId } from './userExternalStudentId';
import type { UserNotificationPreferences } from './userNotificationPreferences';

/**
 * Model for complete, created user record
 */
export interface User {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  role: UserRole;
  /** Lifecycle state for all users. Note that 'stale' and 'finished' primarily apply to students. */
  state?: UserLifecycleState;
  active?: boolean;
  title?: UserTitle;
  trial?: UserTrialProperty;
  cohort?: UserCohort;
  context?: UserContext;
  avatar?: UserAvatar;
  profilePhotoBlobPath?: UserProfilePhotoBlobPath;
  features?: UserFeatures;
  externalStudentId?: UserExternalStudentId;
  id: string;
  notificationPrefs?: UserNotificationPreferences;
}
